import styled, { css } from 'styled-components';
var ScrollBarContainer = styled.div.withConfig({
  displayName: "ScrollBarContainer",
  componentId: "tfxssf-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return css(["::-webkit-scrollbar{width:4px;background:", ";}::-webkit-scrollbar-track{background:", ";}::-webkit-scrollbar-thumb{width:2px;background:", ";border-radius:15px;}::-webkit-scrollbar-thumb:hover{background:", ";}"], theme.colors.gray200, theme.colors.gray200, theme.colors.gray500, theme.colors.gray500);
});
ScrollBarContainer.displayName = 'ScrollBarContainer';
export { ScrollBarContainer };